import styled from 'styled-components';

export const CmsTileGridBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CmsTileGridBlockInputContainer = styled.div`
  margin-bottom: 16px;
  max-width: 100%;
  width: 425px;
  height: 45px;
`;

export const CmsTileGridBlockTabSwitcherContainer = styled.div`
  margin-bottom: 16px;
`;
